import { Button } from "primereact/button";
import { Image } from "primereact/image";
import React from "react";
import { useNavigate } from "react-router-dom";

const KycUnderReview: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        backgroundImage: "url('/assets/images/auth/reviewbg.jpg')",
      }}
      className="bg-white h-screen bg-cover bg-center"
    >
      <div className="flex flex-col justify-center items-center h-full px-6 lg:px-12">
        {/* Text Section */}
        <div className="flex flex-col items-center text-center p-4 max-w-xl">
          <Image
            src="/assets/images/logo.png"
            alt="wacepay logo"
            width="210"
            className="mb-4"
          />
          <h1 className="text-2xl font-bold mb-2 text-black">
            KYC Under Review
          </h1>
          <p className="text-gray-700 w-full">
            Thank you for submitting your KYC documents. Our team is currently
            reviewing them. You will receive an email notification once your
            account has been activated.
          </p>
          <div className="flex flex-wrap mt-5 gap-3">
            <Button
              label="Go back to home"
              className="border-2 border-primary-500 text-black rounded-md px-4 py-2 focus:outline-none"
              onClick={() => navigate("/auth")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycUnderReview;
